(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name commons.service:TabService
     *
     * @description
     *
     */
    angular
        .module('commons')
        .service('TabService', TabService);

    function TabService(localStorageService, $state, $window) {
        var self = this;

        self.addTab = function (tabName) {
            if (getTabIndex(tabName) === -1) {
                addTabByName(tabName);
            }
        };

        self.removeTab = function (tabName) {
            var ind = getTabIndex(tabName);
            if (ind !== -1) {
                removeTabByIndex(ind);
            }
        };

        self.gotoTab = function (tabName, params, attrs) {
            var popup = null;
            var newTabToOpen = false;
            if (angular.isUndefined(params)) {
                params = {};
            }
            var url = $state.href(tabName, params);
            if (getTabIndex(tabName) === -1) {
                self.addTab(tabName);
                newTabToOpen = true;
            }
            popup = getPopupToOpen(url, tabName, params, attrs);
            if(!newTabToOpen){
            	popup.close();
            	popup = getPopupToOpen(url, tabName, params, attrs);
            }
            popup.focus();
        };
        
        function getPopupToOpen(url, tabName, params, attrs){
        	var popup = null;
        	if(angular.isUndefined(attrs)){
                popup = $window.open(url, tabName);
                popup.popup = false;
            }else{
                if(attrs=='popup'){
                    params = 'width=1000,height=800,left=100,top=100'
                }else{
                    params = attrs;
                }
                popup = $window.open(url, tabName, params);
                popup.popup = true;
            }
        	return popup;
        }

        function getTabIndex(tabName) {
            var tabCollection = getTabList();
            return tabCollection.indexOf(tabName);
        }

        function addTabByName(tabName) {
            var tabCollection = getTabList();
            tabCollection.push(tabName);
            localStorageService.set('_tabs', tabCollection);
        }

        function removeTabByIndex(index) {
            var tabCollection = getTabList();
            tabCollection.splice(index, 1);
            localStorageService.set('_tabs', tabCollection);
        }

        function getTabList() {
            return localStorageService.get('_tabs') || [];
        }

    }
}());
